import {FrontendError} from '@/services/ErrorService/FrontendError';

export enum ShareStatus {
  Idle = 'Idle',
  Success = 'Success',
  Aborted = 'Aborted',
  UnknownError = 'UnknownError',
}

export type ShareState = {
  status: ShareStatus;
  error?: FrontendError;
};

export type ShareStoreType = {
  conditionsLink: ShareState;
  projectRef: ShareState;
};
